import axios from 'axios';

const AUTH_TOKEN_KEY = 'auth_token';
const AUTH_USER_KEY = 'auth_user';

const authApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api'
});

const authService = {
  async login(username, password) {
    const response = await authApi.post('/auth/login', { username, password });
    const { token, username: user } = response.data;
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    localStorage.setItem(AUTH_USER_KEY, user);
    return { token, username: user };
  },

  logout() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
  },

  getToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  },

  getUser() {
    return localStorage.getItem(AUTH_USER_KEY);
  },

  isAuthenticated() {
    return !!this.getToken();
  }
};

export default authService;
